import { useApiFetcherSWR } from "hooks/SwrCustom";

export const API_ENDPOINT = {
    GET_SMS_YEARS: {
        url: "site-years",
        method: "get",
    },

    GET_SMS_STATISTICS: (year) => ({
        url: `get-sms-statistics?year=${year}`,
        method: "get",
    }),
};

export const useSmsYears = () =>
    useApiFetcherSWR(API_ENDPOINT.GET_SMS_YEARS);

export const useSmsStatistics = (year) =>
    useApiFetcherSWR(
        year
            ? API_ENDPOINT.GET_SMS_STATISTICS(year)
            : { url: null, method: "get" }
    );